module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"errorText":"Ошибка: неверный url авторизации"}}')
  delete Component.options._Ctor
}
